import { API_endpoints } from "../config";

export const statistic9 = async (): Promise<any> => {
    try {
        const response = await fetch(API_endpoints.statistic9, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({}),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von statistik 9 Daten.");
        }
    

        return await response.json();

        
    } catch (error) {
        console.error("Fehler beim Laden von statistik 9 Daten:", error);
    }
};
